import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PublicationCU {
    date: string;
    title: string;
    type: string;
    htmlText: string;
    images?: File[];
    createdBy?: string;
}

export interface Publication {
    id: number;
    date: string;
    title: string;
    enterprise: string;
    type: string;
    htmlText: string;
    images: Array<string>;
    createdBy: string;
}

@Injectable({
  providedIn: 'root'
})
export class PublicationService {
    //private resourceUrl = 'http://localhost:8080/api/publications';
    private resourceUrl = 'https://api.geekinstitut.com/api/publications'

    constructor(private http: HttpClient) {}

    /* ========= PUBLIC GETS ========= */

    getAll(enterprise: string): Observable<Publication[]> {
        const params = new HttpParams().set('enterprise', enterprise);
        return this.http.get<Publication[]>(this.resourceUrl, { params });
    }

    getAllByType(type: string, enterprise: string): Observable<Publication[]> {
        const params = new HttpParams().set('enterprise', enterprise);
        return this.http.get<Publication[]>(`${this.resourceUrl}/type/${encodeURIComponent(type)}`, { params });
    }

    /** GET /api/publications/{id}?enterprise=... */
    getById(id: number, enterprise: string): Observable<Publication> {
        const params = new HttpParams().set('enterprise', enterprise);
        return this.http.get<Publication>(`${this.resourceUrl}/${id}`, { params });
    }

    /* ========= IMAGES ========= */

    /** GET /api/publications/image?enterprise=...&type=...&id=... -> Blob */
    getFirstImage(enterprise: string, type: string, pubId: number): Observable<Blob> {
        const params = new HttpParams()
            .set('enterprise', enterprise)
            .set('type', type)
            .set('id', pubId.toString());
        return this.http.get(`${this.resourceUrl}/image`, { params, responseType: 'blob' });
    }

    /** GET /api/publications/images?enterprise=...&type=...&id=... -> string[] filenames */
    listImages(enterprise: string, type: string, pubId: number): Observable<string[]> {
        const params = new HttpParams()
            .set('enterprise', enterprise)
            .set('type', type)
            .set('id', pubId.toString());
        return this.http.get<string[]>(`${this.resourceUrl}/images`, { params });
    }

    /** GET /api/publications/{enterprise}/{type}/{id}/images/{filename} -> Blob */
    getImageByFilename(enterprise: string, type: string, pubId: number, filename: string): Observable<Blob> {
        const url = this.buildImageUrlForFilename(enterprise, type, pubId, filename);
        return this.http.get(url, { responseType: 'blob' });
    }

    /** Construit l’URL directe d’une image (utile pour <img [src]> si vous servez en public) */
    buildImageUrlForFilename(enterprise: string, type: string, pubId: number, filename: string): string {
        return `${this.resourceUrl}/${encodeURIComponent(enterprise)}/${encodeURIComponent(type)}/${pubId}/images/${encodeURIComponent(filename)}`;
    }
}
